import SelectDataModal from "./SelectDataModal";

export default SelectDataModal;
